<template>
    <div class="activityCenterList">
        <edit-info :idsArray="ids"></edit-info>
        <edit-info :brandidsArray="brandids"></edit-info>
        <edit-info :isactiveArray="isactive"></edit-info>
        <edit-info :isbindArray="isbind"></edit-info>
        <edit-info :useridArray="userid"></edit-info>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item style="width:187px;">
                    <el-radio v-model="searchForm.team_type" :label="1" @change="typeChange">团队</el-radio>
                    <el-radio v-model="searchForm.team_type" :label="2" @change="typeChange">直营</el-radio>
                </el-form-item>
                <el-form-item>
                    <el-select
                        v-model="searchForm.brand_id"
                        filterable
                        clearable
                        style="width:100%"
                        placeholder="请选择终端类型"
                    >
                        <el-option
                            v-for="(item,index) in brandList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="searchForm.type" clearable placeholder="请选择活动类型">
                        <el-option label="伪激活扣款规则" value="1" ></el-option>
                        <el-option label="交易量达标奖励" value="2" ></el-option>
                        <el-option label="交易量阶梯奖励" value="3" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="searchForm.status" clearable placeholder="请选择达标状态">
                        <el-option label="进行中" value="1"></el-option>
                        <el-option label="已达标" value="2"></el-option>
                        <el-option label="未达标" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="searchForm.terminal_sn" placeholder="请输入终端SN"></el-input>
                </el-form-item>
                <el-form-item v-if="level == 0 || level == 1">
                    <el-input size clearable v-model="searchForm.phone" placeholder="请输入终端归属代理账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="活动开始时间"
                        end-placeholder="活动开始结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            v-model="rangeDates"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="活动结束开始时间"
                            end-placeholder="活动结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="pickerChanges"
                    ></el-date-picker>
                </el-form-item>
                <!-- <el-form-item v-if="level == 0 || level == 1">
                    <el-input size clearable v-model="searchForm.name" placeholder="请输入终端归属代理姓名"></el-input>
                </el-form-item> -->
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="handleSearch(searchForm)"
                    >查询</el-button>
                    <el-button
                        size="small"
                        type="primary"
                        icon="el-icon-download"
                        :loading="downLoading"
                        @click="handleDownLoad(searchForm)"
                    >导出数据</el-button>
<!--                    <el-button-->
<!--                            @click="handleEdit()"-->
<!--                            type="primary"-->
<!--                            size="small"-->
<!--                    >批量修改-->
<!--                    </el-button>-->
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table :data="centerList" size="mini" border style="width: 100%" v-loading="loading" @selection-change="changeFun">
                <el-table-column  header-align="center"  align="center"  fixed type="selection" label="ID" min-width="80" key = "0" v-if="searchForm.type == 4">
                </el-table-column>
                <!-- 序号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                    key = "1"
                ></el-table-column>
                <!-- 终端类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="brand_name"
                    label="终端类型"
                    min-width="150"
                    key = "2"
                ></el-table-column>
                <!-- 终端SN -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="terminal_sn"
                    label="终端SN"
                    min-width="200"
                    key = "3"
                ></el-table-column>
                <!-- 商户名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="merchant_name"
                    label="商户名称"
                    min-width="150"
                    key = "4"
                ></el-table-column>
                <!-- 终端归属代理姓名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="real_name"
                    label="终端归属代理姓名"
                    min-width="120"
                    v-if="level == 0 || level == 1"
                    key = "5"
                ></el-table-column>
                <!-- 终端归属代理账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    label="终端归属代理账号"
                    min-width="120"
                    v-if="level == 0 || level == 1"
                    key = "6"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.phone | desMobile" placement="top">
                      <p>{{ scope.row.phone | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 终端归属代理编号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_no"
                    label="终端归属代理编号"
                    min-width="150"
                    v-if="level == 0 || level == 1"
                    key = "6"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.agent_no" placement="top">
                      <p>{{ scope.row.agent_no | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 活动类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="type_name"
                    label="活动类型"
                    min-width="150"
                    key = "7"
                ></el-table-column>
                <!-- 状态 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="status"
                    label="状态"
                    min-width="100"
                    key = "8"
                ></el-table-column>
                <!-- 进度 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="speed"
                        label="进度"
                        min-width="100"
                        key = "9"
                ></el-table-column>
                <!-- 天数 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="days"
                        label="天数"
                        min-width="150"
                        v-if="searchForm.type == 4"
                        key = "10"
                ></el-table-column>
                <!-- 扣除金额 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="deduction_money"
                        label="扣除金额"
                        min-width="150"
                        v-if="searchForm.type == 4"
                        key = "11"
                ></el-table-column>
                <!-- 活动开始时间 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="start_time"
                        label="活动开始时间"
                        min-width="150"
                        v-if="searchForm.type == 4"
                        key = "19"
                ></el-table-column>
                <!-- 活动结束时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="cut_off_time"
                    label="活动结束时间"
                    min-width="150"
                    key = "20"
                ></el-table-column>
                <!-- 活动结束时间 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="end_time"
                        label="活动结束时间"
                        min-width="150"
                        key = "21"
                        v-if="searchForm.type == 4"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <el-button @click="handleInfo(scope.row)" type="text" size="small">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
        <terminal-detail
                v-if="infoIsShow"
                :infoIsShow="infoIsShow"
                :detail="detail"
                @infoClose="infoClose"
        >
        </terminal-detail>
        <center-info v-if="info.isShow" :info="info" @infoClose="handleCloseInfo"></center-info>
        <edit-info
                v-if="editShow"
                :infoIsShow="editShow"
                :detail="detail"
                :idsArray="ids"
                :brandidsArray="brandids"
                :isactiveArray="isactive"
                :isbindArray="isbind"
                :useridArray="userid"
                @infoClose="infoClose"
        >
        </edit-info>
        <search-result
                v-if="statusIsShow"
                :infoIsShow="statusIsShow"
                :detail="detail"
                @infoClose="infoClose"
        ></search-result>
    </div>
</template>

<script>
import centerInfo from './components/activityCenterInfo';
import editInfo from './MAM_editInfo';
export default {
    name: "activityCenterList",
    data() {
        return {
            info: {
                isShow: false,
                row: {}
            },
            searchForm: {
                page: 1,
                limit: 10,
                team_type: 1,
            },
            ids: [],
            brandids :  [],
            isactive :  [],
            isbind :  [],
            userid :  [],
            detail: {}, //当前行
            pickerOptions: {},
            pickerOptionses: {},
            statusIsShow: false, //弹窗
            infoIsShow: false, //弹窗
            editShow: false, //弹窗
            rangeDate: '',
            rangeDates: '',
            brandList: [],
            centerList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: false,
            downLoading: false, //导出loading
            level: sessionStorage.getItem('level'),
        }
    },
    mounted() {
        this.$api.post('brand/brand_list', {}, res => { //获取终端类型
            if (res.code == 0) {
                this.brandList = res.data.list;
            } else {
                this.$message.success(res.msg);
            }
        });
        this.getData(this.searchForm)
    },
    components: {
        centerInfo,
        editInfo,
    },
    methods: {
        changeFun(row) {
            this.ids = [];
            this.brandids = [];
            this.isactive = [];
            this.isbind = [];
            this.userid = [];
            if (row.length != 0) {
                this._.forEach(row, item => {
                    this.ids.push(item.id);
                    this.brandids.push(item.brand_id);
                    this.isactive.push(item.is_active);
                    this.isbind.push(item.is_bind);
                    this.userid.push(item.user_id);
                })
            }
        },
        infoClose() { //关闭
            this.infoIsShow = false;
            this.statusIsShow = false;
            this.editShow = false;
        },
        handleEdit() {  //编辑
            if (this.ids.length > 0) {
                this.editShow = true;
            } else {
                this.$message.error('请选择终端');
                this.editShow = false;
            }
        },
        typeChange(val) { //监听radio
            this.searchForm.team_type = val;
            this.searchForm.page = 1; //重置
            // 表单提交
            this.getData(this.searchForm);
        },
        handleSearch(searchFrom) { //搜索
            this.currentPage = 1;
            searchFrom.page = 1;
            this.getData(searchFrom);
        },
        handleInfo(row) { //详情
            this.info.isShow = true;
            this.info.row = row;
        },
        handleCloseInfo() { //关闭详情
            this.info.isShow = false;
            this.info.row = {};
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        getData(params) { //获取数据
            this.loading = true;
            this.$api.post("activity_merchant_status/get_activity_merchant_all_list", params, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.count; //总数
                    this.centerList = res.data.list;
                    //渲染结束后取消加载
                } else {
                    this.$message.error(res.msg);
                }
                this.loading = false;
            })
        },
        handleDownLoad(searchForm) { //导出
            this.downLoading = true;
            this.$api.post("activity_merchant_status/get_activity_merchant_status_list_download", searchForm, res => {
                if (res.code == 0) {
                    this.$message.success(res.msg);
                    var link=this.$file_url+res.data;
                    window.open(link)
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.downLoading = false;
            })
        },
        pickerChange(DateArr) { //时间选择器
            this.searchForm.start_start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.start_end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            this.rangeDate = [this.searchForm.start_start_time, this.searchForm.start_end_time];
        },
        pickerChanges(DateArr) { //时间选择器
            this.searchForm.end_start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            this.rangeDates = [this.searchForm.end_start_time, this.searchForm.end_end_time];
        },
    }
}
</script>

<style scoped lang="scss">
</style>